import { Fragment, ReactNode } from "react";
import ClientLayout from "../../components/ClientSpace/ClientLayout/ClientLayout";

function ClientSpace() {
    return <Fragment></Fragment>;
}

ClientSpace.getLayout = (page: ReactNode) => (
    <ClientLayout>{page}</ClientLayout>
);

export default ClientSpace;
